import { Box, Group, Text } from '@mantine/core';
import { TimeInput } from '@mantine/dates';
import { IconClock } from '@tabler/icons-react';

const parseTimeWithTimezone = (time) => {
  if (!time) {
    return '';
  }
  const date = new Date([new Date().toISOString().split('T')[0], time].join('T'));
  return `${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
};

const TimePickerControl = ({
  value,
  onChange,
  size = 'sm',
  prepend,
  append,
  className = '',
  style = {},
  children,
  disabled,
  ...props
}) => {
  const timeValue = parseTimeWithTimezone(value);

  const handleTimeChange = (event) => {
    const newTime = event.target.value;
    if (!newTime) {
      return onChange(null);
    }
    // Create a date object with the time and return ISO-8601 string
    const [hours, minutes] = newTime.split(':').map(Number);
    const date = new Date();
    date.setHours(hours, minutes, 0, 0);
    onChange(date.toISOString().split('T')[1]);
  };

  const timePicker = (
    <TimeInput
      size={size}
      value={timeValue}
      onChange={handleTimeChange}
      disabled={disabled}
      {...props}
      leftSection={<IconClock size={16} />}
    />
  );

  // If we have prepend or append, wrap in a Group
  if (prepend || append) {
    return (
      <Box className={className} style={style}>
        <Group gap="xs" wrap="nowrap">
          {prepend && (
            <Text size="sm" c="dimmed" style={{ whiteSpace: 'nowrap' }}>
              {prepend}
            </Text>
          )}
          <Box style={{ flex: 1 }}>{timePicker}</Box>
          {append && (
            <Text size="sm" c="dimmed" style={{ whiteSpace: 'nowrap' }}>
              {append}
            </Text>
          )}
        </Group>
        {children && <Box mt="xs">{children}</Box>}
      </Box>
    );
  }

  return (
    <Box className={className} style={style}>
      {timePicker}
      {children && <Box mt="xs">{children}</Box>}
    </Box>
  );
};

export default TimePickerControl;
